export default "__VITE_ASSET__BPuvdwyK__"